module.exports = __webpack_public_path__ + "static/media/events11.ce5eb92e.png";